var Curriculog = Curriculog || {};

Curriculog.ApiSecrets = (function ($, _, Backbone, ApiSecrets) {


        ApiSecrets = Curriculog.CurriculogCollection.extend({
            url: '/rest/apisecret',
            model: Curriculog.ApiSecret,
        });

        return ApiSecrets;

})($, _, Backbone, Curriculog.ApiSecrets || {});
